import React from 'react';

import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';

import media from '../../../theme/media';

const getAlignment = (props) => {
    switch (props.align) {
        case 'start':
            return 'start';
        case 'center':
            return 'center';
        case 'end':
            return 'end';
    }
};

const getJustify = (props) => {
    switch (props.justify) {
        case 'start':
            return 'flex-start';
        case 'center':
            return 'center';
        case 'end':
            return 'flex-end';
        case 'between':
            return 'space-between';
    }
};

const getBottomIndent = (props) => {
    switch (props.indent) {
        case '4px':
            return '4px';
        case '8px':
            return '8px';
        case '12px':
            return '12px';
        case '16px':
            return '16px';
        case '24px':
            return '24px';
        case '32px':
            return '32px';
        case '48px':
            return '48px';
        case '64px':
            return '64px';
        case 'adaptive-8-16':
            return '8px';
        case 'adaptive-16-24':
            return '16px';
        case 'adaptive-24-32':
            return '24px';
        case 'adaptive-32-48':
            return '32px';
        case 'adaptive-48-64':
            return '48px';
        default:
            return null;
    }
};
const getDesktopBottomIndent = (props) => {
    switch (props.indent) {
        case '4px':
            return '4px';
        case '8px':
            return '8px';
        case '12px':
            return '12px';
        case '16px':
            return '16px';
        case '24px':
            return '24px';
        case '32px':
            return '32px';
        case '48px':
            return '48px';
        case '64px':
            return '64px';
        case 'adaptive-8-16':
            return '16px';
        case 'adaptive-16-24':
            return '24px';
        case 'adaptive-24-32':
            return '32px';
        case 'adaptive-32-48':
            return '48px';
        case 'adaptive-48-64':
            return '64px';
        default:
            return null;
    }
};
const getDirection = (props) => {
    if (props.flex) {
        if (props.direction === 'column') {
            return 'column';
        }
        return 'row';
    }
    return null;
};
const getTextAlign = (props) => {
    switch (props.textAlign) {
        case 'center':
            return 'center';
        case 'right':
            return 'right';
        default:
            return null;
    }
};

const CommonCss = css`
    display: ${(props) => (props.flex && props.type === 'span' ? 'inline-flex' : props.flex ? 'flex' : 'block')};
    flex-direction: ${(props) => getDirection(props)};
    align-items: ${(props) => getAlignment(props)};
    justify-content: ${(props) => getJustify(props)};
    flex-wrap: ${(props) => (props.flexwrap ? 'wrap' : null)};
    margin-bottom: ${(props) => getBottomIndent(props)};
    overflow: ${(props) => (props.overflow ? 'hidden' : null)};
    text-align: ${(props) => getTextAlign(props)};

    ${media.desktop1920} {
        margin-bottom: ${(props) => getDesktopBottomIndent(props)};
    }
`;

const ContainerBlock = styled.div`
    ${CommonCss}
`;
const ContainerSpan = styled.span`
    ${CommonCss}
`;
const ContainerListItem = styled.li`
    ${CommonCss}
`;

export const Row = (props) => {
    const Wrapper = props.type === 'listItem' ? ContainerListItem : 'span' ? ContainerSpan : ContainerBlock;
    return <Wrapper {...props}>{props.children}</Wrapper>;
};

Row.propTypes = {
    type: PropTypes.oneOf(['listItem', 'span']),
    flex: PropTypes.bool,
    direction: PropTypes.oneOf(['row', 'column']),
    align: PropTypes.oneOf(['start', 'center', 'end']),
    justify: PropTypes.oneOf(['start', 'center', 'end', 'between']),
    indent: PropTypes.oneOf([
        '0',
        '4px',
        '8px',
        '12px',
        '16px',
        '24px',
        '32px',
        '48px',
        '64px',
        'adaptive-8-16',
        'adaptive-16-24',
        'adaptive-24-32',
        'adaptive-32-48',
        'adaptive-48-64',
    ]),
    overflow: PropTypes.bool,
    textAlign: PropTypes.oneOf(['center', 'right']),
    flexwrap: PropTypes.bool,
    children: PropTypes.any,
};
